import { Component } from 'react'
import getEventValues from '../func/getInitValues';
import EditEventForm from '../present/EditEventForm'
class EditEventFormContainer extends Component {
    constructor(props) {
        super(props);

        this.getChanges = this.getChanges.bind(this)
        this.onUpdateData = this.onUpdateData.bind(this)
        this.checkChanges = this.checkChanges.bind(this)
        this.getEmailUrl = this.getEmailUrl.bind(this)
        this.onSenMail = this.onSendMail.bind(this)
    }

    getInitValues() {
        const { event } = this.props
        return getEventValues(event)
    }

    getChanges(formValues, initValues, values, changes = {}) {
        Object.keys(initValues).map(key => {
            const formValue = formValues[key]
            const initValue = initValues[key]
            const value = values[key]

            if('object' === typeof initValue) {
                const c = this.getChanges(formValue, initValue, value)

                if(Object.keys(c).length) {
                    changes[key] = c
                }
            } else if(initValue != value) {
                changes[key] = value
            }
        })

        return changes
    }

    checkChanges(formValues, initValues, values)  {
        const changes = this.getChanges(formValues, initValues, values)
        return 0 !== Object.keys(changes).length
    }

    onUpdateData(formValues, initValues, values) {
        const { event, onUpdateEvent } = this.props
        const changes = this.getChanges(formValues, initValues, values)

        onUpdateEvent(event.id, changes)
    }

    onSendMail(formValues, initValues, values) {
        const { event, onSendMail } = this.props
        onSendMail(event.id)
    }

    getEmailUrl()  {

    }

    render() {
        const { status, error, event, settings, currentLang, timezone, debug, onCancel }  =  this.props 
        const initValues = this.getInitValues()

        return <EditEventForm 
            status={status}
            error={error}
            event={event}
            eventInitValues={initValues}
            settings={settings}
            currentLang={currentLang}
            timezone={timezone}
            debug={debug}
            checkChanges={this.checkChanges}
            onUpdateData={this.onUpdateData}
            onCancel={onCancel}
            onSendMail={this.onSenMail}
        />
    }
}

export default EditEventFormContainer